import React from 'react';

export const ToolTipTrigger = (props) => (
	<button 
		onClick={props.handleClick}
        className="tooltip-trigger" />
);


// WEBPACK FOOTER //
// ./src/components/ToolTip/ToolTipTrigger.js